import { Button, Modal, Stack } from '@mantine/core';

type ThumbnailPreviewModalProps = {
  showPreview: boolean;
  setShowPreview: (value: boolean) => void;
  previewUrl: string | null;
};

export function ThumbnailPreviewModal({ 
  showPreview, 
  setShowPreview, 
  previewUrl 
}: ThumbnailPreviewModalProps) {
  return (
    <Modal
      opened={showPreview}
      onClose={() => setShowPreview(false)}
      title="Preview Thumbnail"
      size="xl"
      styles={{
        root: {
          pointerEvents: 'auto'
        },
        overlay: {
          pointerEvents: 'auto'
        },
        inner: {
          pointerEvents: 'auto'
        },
        content: {
          pointerEvents: 'auto'
        }
      }}
    >
      {previewUrl && (
        <Stack>
          <img 
            src={previewUrl} 
            alt="Generated thumbnail" 
            style={{ width: '100%', height: 'auto' }}
          />
          <Button
            component="a"
            href={previewUrl}
            download="thumbnail.jpg"
            target="_blank"
          >
            Download
          </Button>
        </Stack>
      )}
    </Modal>
  );
} 